module.exports = __webpack_public_path__ + "img/icn_check_hv_roller.13953b2f.png";